import { useSelector } from 'react-redux';
import * as newSalesActions from 'store/newSales/actions';
import * as newSalesSelectors from 'store/newSales/selectors';
import useAction from 'hooks/useAction';
import InfiniteScroll from 'components/molecules/InfiniteScroll/InfiniteScroll';
import { QUERY_PARAMS } from 'consts/queryParams';
import { getQueryParam } from 'functions/urlHelpers';

const LoadMoreNewSales = ({ children }) => {
  const fetchNewSales = useAction(newSalesActions.requestGetNewSales);
  const { isFetching, page, newSalesLeft } = useSelector(newSalesSelectors.getLoadMoreData);
  const biscotti = getQueryParam(QUERY_PARAMS.biscotti);

  return (
    <InfiniteScroll
      fetchMore={() => fetchNewSales({ page: page + 1, biscotti })}
      isFetching={isFetching}
      left={newSalesLeft}
      spacing={38}
      direction="column"
    >
      {children}
    </InfiniteScroll>
  );
};

export default LoadMoreNewSales;
